import { render, staticRenderFns } from "./dataPoint.vue?vue&type=template&id=372b89c3&"
import script from "./dataPoint.vue?vue&type=script&lang=js&"
export * from "./dataPoint.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports